/* ========================================================================
 *  module feedback
 * ========================================================================
*/
FD.PROJECTEDIT = (function ($, me) {
    'use strict';

    var child = me.PROJECTEDIT || {};


    /* ========================================================================
     *  vars
     * ========================================================================
    */
    var URL_MODULES = '/Projects/Modules/';
    var URL_PROJECTS = '/Projects/Projects/';

    var MESSAGE_CONTAINER_ELEM = '[data-modalmessage="true"]';
    var PARENT_ELEM = '[data-parent="true"]';
    var TASK_MONTHLY_MODAL = '#TASK_MONTHLY_MODAL';
    var MODAL_ELEM = '#PROJECTEDIT_MODAL';
    var MONTHLY_WARNING = '#MONTHLY_WARNING';
    var LINK_LIST = '#PROJECTEDIT_LINK_LIST';
    var LINK_CONTAINER = '#PROJECT_LINK_CONTAINER';
    var ATTACH_FILE_MODAL = '#ATTACH_FILE_MODAL';
    var lastupdatesection = '[data-lastupdatesection="true"]',
        LAST_UPDATED_BY = '#LAST_UPDATED_BY',
        LAST_UPDATED_DATE = '#LAST_UPDATED_DATE';
    var INPUT_ENTITY_ID = "#INPUT_ENTITY_ID";
    var LI_FINANCIALIMPACT = "#LI_FINANCIALIMPACT";
    var SUPPORTING_DOCUMENTATION_ROW_DATA = "#SUPPORTING_DOCUMENTATION_ROW_DATA";
    var IMAGE_ROWDATA = "#IMAGE_ROWDATA";
    var PROJECT_TASK_TABLE = "#PROJECT_TASK_TABLE";
    var PROJECT_VALIDATION_STATUS = "#PROJECT_VALIDATION_STATUS";
    var PROJECT_UPDATED_BY = "#PROJECT_UPDATED_BY";
    var label = null;

    var modal;
    var messageModalContainer = $(MESSAGE_CONTAINER_ELEM);
    var accountEntityType = 29;
    var showEdit = false;
    var savedProject = false;
    var callbackFunction = null;
    var currentProjectID = -1;
    var notify = new Notify();

    var OVERALL_STATUS = "#PROJECT_EDIT_TASK_STATUS";
    var SAFETY_ID = 1347;
    var QUALITY_IMPROVEMENT_TOOLS_ID = 1377;
    var paybackMonthElem;
    var implementationCostElem;
    var annualValueElem;
    var annualValueWithImplementationElem;
    var projectCompletedDate;
    var impactForecastType = {
        Implementation: -1,
        Annual: 101,
        Part: 102,
        People: 103
    };
    var taskID;
    var metricItem;

    var entityTypeEnum = {
        Cell: 2,
        SC: 35
    };

    /* ========================================================================
     *  tags
     * ========================================================================
    */

    var tag = {

        // Edit Tab
        EDIT_ProjectTitle: 10,
        EDIT_OwnerID: 11,
        EDIT_EntityID: 12,
        EDIT_Priority: 13,
        EDIT_IsTop50: 14,
        EDIT_StartDate: 15,
        EDIT_ForecastedCompletionDate: 16,
        EDIT_EndDateInitial: 17,
        EDIT_ActualCompletedDate: 18,
        EDIT_People: 19,
        EDIT_Plan: 20,
        EDIT_Action: 21,
        EDIT_IsComplete: 22,
        EDIT_IsComplete_Promote: 33,
        EDIT_Tasks_IsComplete: 34,
        EDIT_WasSuccessful: 29,
        EDIT_Comment: 23,
        EDIT_ProjectScope: 24,
        EDIT_DefinitionOfDone: 25,
        EDIT_Top50Category: 26,
        CREATE_JOB: 27,
        EDIT_JobID: 28,
        EDIT_EstimatedHours: 31,
        EDIT_Custom: 32,

        // Collections Tab
        CHECK_COLLECTION_PROJECT: 30,

        // Metric Tab
        CHECK_METRIC: 60,
        EDIT_METRIC_IsRequired: 66,
        EDIT_METRIC_IsRequired_Date: 67,
        EDIT_IsFMEARPNReduction: 61,
        EDIT_FMEALineNumber: 62,
        EDIT_CurrentRPN: 63,
        EDIT_RPNReduction: 64,
        EDIT_SafetyType: 65,

        // Associated Entities Tab
        ADD_ENTITY: 70,
        DELETE_ENTITY: 71,

        SAVE_LINK: 72,
        DELETE_LINK: 73,

        // Other
        DELETE_PROJECT: 80,

        TOGGLE_SECTION: 90,

        UPLOAD_FILE: 200,
        REMOVE_FILE: 201,

        ADD_IMAGE: 205,
        CLICK_IMAGE: 206,
        CLICK_IMAGE_WITH_PREFIX: 2206,

        //Task
        ADD_TASK: 100,
        DELETE_TASK: 101,
        EDIT_TASK_Title: 102,
        EDIT_TASK_EntityID: 103,
        EDIT_TASK_OwnerID: 104,
        EDIT_TASK_ForecastedCompletionDate: 105,
        EDIT_TASK_ActualCompletionDate: 124,
        EDIT_TASK_ImpactOffset: 106,
        EDIT_TASK_ImpactAccountID: 107,
        EDIT_TASK_ImpactType: 108,
        EDIT_TASK_CalculationType: 109,
        EDIT_TASK_PartID: 110,
        EDIT_TASK_PurchasedMaterialID: 111,
        EDIT_TASK_PerPieceValue: 112,
        EDIT_TASK_IsSoftCost: 113,
        EDIT_TASK_Duration: 114,
        EDIT_TASK_Probability: 115,
        EDIT_TASK_IsValidated: 116,
        EDIT_TASK_IsCompleted: 117,
        EDIT_TASK_Comment: 118,
        EDIT_TASK_OneTimeValue: 119,
        EDIT_TASK_AnnualValue: 120,
        EDIT_TASK_TaskStatusType: 125,
        COPY_TASK: 126,

        TASK_MONTHLY_METRIC: 121,

        EDIT_PROJECT_ForecastedCompletionDate: 122,
        HIDE_MODAL: 123,
    };


    /* ========================================================================
     *  object functions
     * ========================================================================
    */

    // create a project object
    function setProjectItem() {
        return {
            ID: currentProjectID,
            ProjectTitle: null,
            OwnerID: null,
            EntityID: null,
            AccountID: null,
            StartDate: null,
            EndDate: null,
            AnnualValue: null,
            CurrencyType: null,
            Comment: null,
            Custom: null,
            People: null,
            Action: null,
            Plan: null,
            IsTop50: null,
            IsOTE: null,
            Priority: null,
            IsComplete: null,
            ForecastedCompletionDate: null,
            ActualCompletedDate: null,
            EndDateInitial: null,
            IsLate: null,
            Probability: null,
            ImplementationCost: null,
            AnnualWithImplementation: null,
            EffortHour: null,
            EffortValue: null,
            ProjectScope: null,
            DefinitionOfDone: null,
            Top50Category: null,
            JobID: null,
            EstimatedHours: null,
            IsOTEValidated: null
        };
    }

    function setProjectTaskItem(taskID) {
        return {
            ID: taskID,
            ProjectID: currentProjectID,
            Title: null,
            EntityID: null,
            OwnerID: null,
            ForecastedCompletionDate: null,
            ImpactType: null,
            ImpactOffset: null,
            ImpactAccountID: null,
            CalculationType: null,
            PartID: null,
            PurchasedMaterialID: null,
            PerPieceValue: null,
            OneTimeValue: null,
            AnnualValue: null,
            Duration: null,
            Probability: null,
            IsValidated: null,
            IsCompleted: null,
            IsSoftCost: null,
            Comment: null,
            TaskStatusType: null
        };
    }

    function setProjectCollectionItem(filterID) {
        return {
            TaskID: currentProjectID,
            FilterID: filterID
        };
    }


    function setProjectMetricItem(ID) {
        return {
            ID: ID,
            taskID: taskID,
            SafetyType: null,
            IsFMEARPNReduction: null,
            FMEALineNumber: null,
            CurrentRPN: null,
            RPNReduction: null
        };
    }


    /* ========================================================================
     *  initial setup
     * ========================================================================
    */


    //  load modal
    function getEditProjectModal(addTask = false, showTaskSection = false) {
        label = label || me.getLabel();
        if (me.getModalLock()) {
            return;
        }
        me.setModalLock(true);
        var options = {
            params: {
                projectID: currentProjectID,
                showTaskSection: addTask || showTaskSection
            },
            url: URL_MODULES + 'GetEditProjectModal',
            callback: afterData,
            ishtml: true,
            cancelprevious: true,
            isloader: true
        };
        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;

            $('body').append(result);

            modal = $(MODAL_ELEM);

            modal.off().on('shown.bs.modal', function () {
                me.CONTROL.setValidateContainer(null); // MUST BE FIRST
                modal.enableControls();

                // save commonly used elements
                paybackMonthElem = modal.find("#PAYBACKMONTH");
                implementationCostElem = modal.find("#IMPLEMENTATION_COST");
                annualValueElem = modal.find("#ANNUAL_VALUE");
                annualValueWithImplementationElem = modal.find("#ANNUAL_WITH_IMPLEMENTATION");

                var link = $("a", LI_FINANCIALIMPACT);
                if ($(LI_FINANCIALIMPACT).hasClass("disabled")) {
                    link.on("click", function () {
                        return false;
                    });
                }
                if (addTask) {
                    handleProjectAddTaskCRUD();
                }
                addFileAttachmentModalElement();

                me.setModalLock(false);
            }).on('hidden.bs.modal', function () {
                removeFileAttachmentModalElement();
                handleEditProjectModalCleanup();
            }).modal('show');

        }
    }

    function addFileAttachmentModalElement() {
        const fileDiv = $(ATTACH_FILE_MODAL);
        if (fileDiv.length > 0) {
            $(ATTACH_FILE_MODAL).remove();
        }
        $("body").append('<div class="modal fade" id="ATTACH_FILE_MODAL" tabindex="1" data-keyboard="false" data-backdrop="static"></div>');
    }

    function removeFileAttachmentModalElement() {
        $(ATTACH_FILE_MODAL).remove();
    }

    /* ========================================================================
     *  CRUD Functions
     * ========================================================================
    */

    // prepare project field update
    function setProjectFieldCRUD(data) {
        var strReplace = 'EDIT_';
        var fldName;

        for (var n in tag) {
            if (tag[n] === data.tag) {
                fldName = n.replace(strReplace, '');
                break;
            }
        }

        var projectItem = setProjectItem();
        projectItem[fldName] = data.value;

        if (data.tag === tag.EDIT_IsTop50) {
            $(MODAL_ELEM).find('.top50category').toggleClass('hidden', !data.value);
            if (!data.value) { //Not Top50
                $(MODAL_ELEM).find('[data-tag="' + tag.EDIT_Top50Category + '"]', PROJECTEDIT_MODAL).val(-1);
                projectItem.Top50Category = -1;
            } else {
                return;
            }
        }

        if (!me.CONTROL.validate(PROJECTEDIT_MODAL, null, data.tag === tag.EDIT_IsTop50)) {
            return false;
        }



        if (data.tag === tag.EDIT_Top50Category) {
            projectItem.IsTop50 = $("[data-tag=" + tag.EDIT_IsTop50 + "]", PROJECTEDIT_MODAL).data("value");
        }


        handleProjectFieldCRUD(projectItem);
    }


    // submit project field update to server
    function handleProjectFieldCRUD(projectItem) {
        var options = {
            url: URL_MODULES + "HandleProjectFieldCRUD",
            params: {
                item: projectItem
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            if (data.data) {
                returnProjectLastUpdatedStatus();
            }
        }
    }


    // Update forecasted completion date (done separately due to necessary database calculations)
    function handleProjectForecastCompletionDateCRUD(getForecastDate = false) {
        var item = setProjectItem();
        item.ForecastedCompletionDate = projectCompletedDate;

        var options = {
            url: URL_MODULES + "HandleProjectForecastCompletionDateCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            $(MODAL_ELEM).find('[data-tag="' + tag.EDIT_TASK_ForecastedCompletionDate + '"]').data('projectcompletiondate', projectCompletedDate);
            returnProjectLastUpdatedStatus();
            if (getForecastDate) {
                getProjectForecastCompletedDate();
            }
        }
    }

    // Update project Plan/Action/People Status, and update overall status accordingly
    function handleProjectTaskStatusCRUD(data) {
        var item = setProjectItem();
        switch (data.tag) {
            case tag.EDIT_People:
                item.People = data.value;
                break;
            case tag.EDIT_Plan:
                item.Plan = data.value;
                break;
            case tag.EDIT_Action:
                item.Action = data.value;
                break;
            case tag.EDIT_WasSuccessful:
                item.WasSuccessful = data.value;
                break;
        }

        var options = {
            url: URL_MODULES + "HandleProjectTaskStatusCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(OVERALL_STATUS).data('value', result);
                me.CONTROL.setStatus(true, MODAL_ELEM);
            }
        }
    }


    // Mark project as completed and update overall status accordingly
    function handleProjectIsCompleteCRUD(data) {
        var item = setProjectItem();
        item.IsComplete = data.value;
        item.CompleteProjectTasks = false;

        var options = {
            url: URL_MODULES + "HandleProjectIsCompleteCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(OVERALL_STATUS).data('value', result);
                me.CONTROL.setStatus(true, MODAL_ELEM);
                if (item.IsComplete) {
                    getProjectCompletedDate();
                } else {
                    $("[data-tag=" + tag.EDIT_WasSuccessful + "]").updateCheckbox({ value: false });
                    $('[data-completeddate="true"]').val('');
                }

                $("[data-tag=" + tag.EDIT_WasSuccessful + "]")
                    .updateCheckbox({ enable: item.IsComplete })
                    .closest("td").toggleClass("edit", item.IsComplete);
                $('#SUCCESSFUL_ALERT').toggleClass('hidden', !item.IsComplete);
                returnProjectLastUpdatedStatus();
            }
        }
    }

    function handleProjectTaskIsComplete() {
        var item = setProjectItem();
        item.IsComplete = true;
        item.CompleteProjectTasks = true;

        var options = {
            url: URL_MODULES + "HandleProjectIsCompleteCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                returnTasksByProject();
                returnProjectLastUpdatedStatus();
            }
        }
    }


    // Get the date a project was completed, and update the completed date field
    function getProjectCompletedDate() {
        var options = {
            url: URL_MODULES + "GetProjectCompletedDate",
            params: {
                ID: currentProjectID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $(MODAL_ELEM).find('[data-tag="' + tag.EDIT_ActualCompletedDate + '"]').val(result);
        }
    }

    function getProjectForecastCompletedDate() {
        var options = {
            url: URL_MODULES + "GetProjectForecastCompletedDate",
            params: {
                ID: currentProjectID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $(MODAL_ELEM).find('[data-tag="' + tag.EDIT_ForecastedCompletionDate + '"]').val(result);
        }
    }


    function getCreateJobModal(projectTitle) {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            me.TIMETRACKER.getCreateJobModal({
                addCallback: placeNewJobInProjectModule,
                hideCallback: showProjectModule,
                initialTitle: projectTitle
            });
        }).modal('hide');
    }


    function placeNewJobInProjectModule(callbackData) {
        var options = {
            url: URL_MODULES + "ReturnJobByID",
            params: {
                jobID: callbackData.NewJobID
            },
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(MODAL_ELEM + ' [data-fldname="JobID"]').data({
                    value: callbackData.NewJobID,
                    initial: result.data.JobName
                }).attr({
                    'data-value': callbackData.NewJobID,
                    'data-initial': result.data.JobName
                }).val(result.data.JobName);

                setProjectFieldCRUD({ tag: tag.EDIT_JobID, value: callbackData.NewJobID });
            }
        }
    }

    function validateEntityType(data) {
        var annualValue = parseFloat(annualValueElem.text().replace(/,/g, ''));
        var selectedEntityType = data.raw.entitytype;
        if (annualValue != 0 && selectedEntityType !== entityTypeEnum.Cell) {
            $(INPUT_ENTITY_ID).data({
                value: data.e.data("initialValue"),
                initial: data.initial
            }).attr({
                'data-value': data.e.data("initialValue"),
                'data-initial': data.initialLI_FINANCIALIMPACT
            }).val(data.initial);
            notify.alert(label["PleaseSelectCellOrSetAnnualSavingsToZero"]);

            return;
        }

        $(LI_FINANCIALIMPACT).toggleClass("disabled", selectedEntityType !== entityTypeEnum.Cell);
        var link = $("a", LI_FINANCIALIMPACT);
        if (selectedEntityType === entityTypeEnum.Cell) {
            $(LI_FINANCIALIMPACT).toggleClass("disabled", false);
            link.attr("href", link.data("href"));
            link.off("click");
        } else {
            $(LI_FINANCIALIMPACT).toggleClass("disabled", true);
            link.attr("href", "");
            link.on("click", function () {
                return false;
            });
        }

        $(MODAL_ELEM + ' [data-fldname="EntityID"]').data("initialValue", data.value);
        $(MONTHLY_WARNING).toggleClass('hidden', selectedEntityType !== entityTypeEnum.SC);
        handleProjectEntityOwnerCRUD(data);
    }

    // Update the primary entity owner for this project
    function handleProjectEntityOwnerCRUD(data) {
        var item = setProjectItem();
        item.EntityID = data.value;

        var options = {
            url: URL_MODULES + "HandleProjectEntityOwnerCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            if (data.data) {
                returnProjectLastUpdatedStatus();
            }
        }
    }


    // Determine which project function to use
    function handleProjectCollectionCRUD(data) {
        if (data.value) {
            handleFilterProjectAddCRUD(data);
        } else {
            handleFilterProjectDeleteCRUD(data);
        }
    }


    // add this project to a collection
    function handleFilterProjectAddCRUD(data) {
        var item = setProjectCollectionItem(data.parentid);

        var options = {
            url: URL_PROJECTS + "HandleCollectionProjectAddCRUD",
            params: {
                inputParams: item
            },
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    // remove this project from a collection
    function handleFilterProjectDeleteCRUD(data) {
        var item = setProjectCollectionItem(data.parentid);

        var options = {
            url: URL_PROJECTS + "HandleCollectionProjectDeleteCRUD",
            params: {
                inputParams: item
            },
            isloader: true
        };

        me.AJAX.setAJAX(options);
    }


    // check/uncheck a project metric
    function checkProjectMetric(data) {
        if (data.value) {
            handleProjectTaskMonthlyMetricCRUD(data);
        } else {
            handleProjectTaskMonthlyMetricDeleteCRUD(data);
        }
    }


    function returnMetricList() {
        var options = {
            url: URL_MODULES + "ReturnMetricList",
            params: {
                taskID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(TASK_MONTHLY_MODAL).off('hidden.bs.modal').html(result).on('hidden.bs.modal', function () {
                    $('body').addClass("modal-open");
                }).enableControls();
            }
        }
    }

    // uncheck a project metric
    function handleProjectTaskMonthlyMetricDeleteCRUD(data) {
        var item = setProjectMetricItem(data.parentid);

        var options = {
            url: URL_MODULES + "HandleProjectTaskMonthlyMetricDeleteCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            returnMetricList();
        }
    }

    // Update Quality Improvement Tools or Safety Type for Project Metrics
    function handleProjectTaskMonthlyMetricCRUD(data) {
        var item = setProjectMetricItem(data.parentid);
        switch (data.tag) {
            case tag.EDIT_IsFMEARPNReduction:
                item.IsFMEARPNReduction = data.value;
                break;
            case tag.EDIT_FMEALineNumber:
                item.FMEALineNumber = data.value;
                break;
            case tag.EDIT_CurrentRPN:
                item.CurrentRPN = data.value;
                break;
            case tag.EDIT_RPNReduction:
                item.RPNReduction = data.value;
                break;
            case tag.EDIT_SafetyType:
                item.SafetyType = data.value;
                break;
        }

        var options = {
            url: URL_MODULES + "HandleProjectTaskMonthlyMetricCRUD",
            params: {
                item: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            returnMetricList();
        }
    }

    function handleProjectIsRequiredCRUD(item) {

        var options = {
            url: URL_MODULES + "HandleProjectIsRequiredCRUD",
            params: {
                updateItem: item
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            returnMetricList();
        }
    }

    function openSelectMonthModal(data) {
        metricItem = {
            MetricID: data.parentid,
            IsRequired: data.value,
            TaskID: taskID
        };

        var options = {
            url: URL_MODULES + "OpenSelectMonthModal",
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            if (data.data) {
                $(TASK_MONTHLY_MODAL).html(data.data).on('hidden.bs.modal', function () {
                    var item = {
                        parentid: taskID
                    };
                    openTaskMonthlyMetricModal(item);
                }).enableControls();
            }
        }
    }


    // associate an additional entity with this project
    function associateProjectEntity(data) {
        var options = {
            url: URL_MODULES + "HandleProjectEntityOwnerAddCRUD",
            params: {
                projectID: currentProjectID,
                entityID: data.value
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $(MODAL_ELEM).find("#EDIT_PROJECT_ENTITY_LIST").html(result);
            $(MODAL_ELEM).find('[data-tag="' + tag.ADD_ENTITY + '"]').val('');
            me.CONTROL.setButton(true, null);
            returnProjectLastUpdatedStatus();
        }
    }


    // disassociate an additional entity with this project
    function disassociateProjectEntity(data) {
        var options = {
            url: URL_MODULES + "HandleProjectEntityOwnerDeleteCRUD",
            params: {
                projectID: currentProjectID,
                entityID: data.parentid
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            $(MODAL_ELEM).find("#EDIT_PROJECT_ENTITY_LIST").html(result);
            me.CONTROL.setButton(true, null);
            returnProjectLastUpdatedStatus();
        }
    }


    function handleProjectDeleteCRUD(data) {
        var options = {
            url: URL_MODULES + "HandleProjectDeleteCRUD",
            params: {
                ID: currentProjectID
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(MODAL_ELEM).modal('hide');
            }
        }
    }


    function handleLinkAddCRUD(data) {
        var linkInput = $(MODAL_ELEM).find('[data-urlend]');
        var linkList = $(LINK_LIST).find('[data-linkurl]');

        if (linkInput.val().length < 1) {
            linkInput.addClass('form-error');
            return;
        } else {
            linkInput.removeClass('form-error');
        }
        for (var i = 0; i < linkList.length; i++) {
            if ($(MODAL_ELEM).find('[data-urlstart]').val() + linkInput.val().trim().toLowerCase() === $(linkList[i]).text().trim().toLowerCase()) {
                notify.alert(label['LinkAlreadyExist']);
                return;
            }
        }
        var options = {
            url: URL_MODULES + "HandleProjectLinkAddCRUD",
            params: {
                projectID: currentProjectID,
                LinkURL: $(MODAL_ELEM).find('[data-urlstart]').val() + linkInput.val().trim()
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(LINK_LIST).html(result.data);
                $(MODAL_ELEM).find('[data-urlend]').val('');
                me.CONTROL.setButton(true, LINK_LIST);
            }
        }
    }


    function handleLinkDeleteCRUD(data) {
        var options = {
            url: URL_MODULES + "HandleProjectLinkDeleteCRUD",
            params: {
                projectID: currentProjectID,
                LinkURL: data.e.closest('.list-group-item').find('[data-linkurl]').text()
            },
            callback: afterData,
            ishtml: true,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(LINK_LIST).html(result.data);
                me.CONTROL.setButton(true, LINK_LIST);
            }
        }
    }

    function expandCollapseSection(data) {
        if (data.e.find('i').hasClass('fa-caret-right')) {
            $('.box-content,.panel-body', data.e.closest('.box,.panel')).removeClass('hidden');
            data.e.find('i').removeClass('fa-caret-right').addClass('fa-caret-down');
        } else {
            $('.box-content,.panel-body', data.e.closest('.box,.panel')).addClass('hidden');
            data.e.find('i').removeClass('fa-caret-down').addClass('fa-caret-right');
        }
    }

    function uploadFile(data) {

        if (!me.CONTROL.Validate(ATTACH_FILE_MODAL)) {
            return;
        }
        var item = me.getFormFields(ATTACH_FILE_MODAL);

        var formData = new FormData();
        var invalidFilename = false;
        var secondarykeyid = data.e.closest(".modal-dialog").data("secondarykeyid");

        $.each(item.File, function (key, value) {
            if (this.name.search(/#/) > -1) {
                invalidFilename = true;
            }
            formData.append(this.name, value);
        });

        if (invalidFilename) {
            notify.alert(label['SymbolsNotSupported']);
            return;
        }

        const ProjectAttachment = 704;
        formData.append("EntityID", currentProjectID);
        formData.append("EntityTypeID", ProjectAttachment);
        formData.append("EntityType", -1);
        formData.append("AttachmentType", item.AttachmentType);
        formData.append("SecondaryKeyID", secondarykeyid);

        var options = {
            url: URL_MODULES + 'UploadFile',
            params: formData,
            callback: afterData,
            isloader: true,
            processData: false,
            contentType: false,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnProjectAttachmentList();
                $(ATTACH_FILE_MODAL).modal('hide');
            }
        }
    }


    function handleProjectAttachmentDeleteCRUD(data) {
        var options = {
            url: URL_MODULES + 'HandleProjectAttachmentDeleteCRUD',
            params: {
                id: data.parentid,
                documentid: data.value
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnProjectAttachmentList();
            }
        }
    }


    function returnProjectAttachmentList() {
        var options = {
            url: URL_MODULES + 'ReturnProjectAttachmentList',
            params: {
                projectID: currentProjectID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(SUPPORTING_DOCUMENTATION_ROW_DATA).html(result.data).enableControls();
            }
        }
    }

    function returnProjectImageList() {
        var options = {
            url: URL_MODULES + "ReturnProjectMediaList",
            params: {
                projectID: currentProjectID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                $(IMAGE_ROWDATA).html(result.data).enableControls();
            }
        }
    }

    function handleImageUpdateCRUD(data, removed) {
        return function (mediaID) {
            if (!removed) {
                $(UPLOAD_MEDIA_MODAL).modal("hide");
                handleProjectMediaAddCRUD(mediaID);
            } else {
                handleProjectMediaDeleteCRUD(mediaID);
            }
        };
    }

    function handleProjectMediaAddCRUD(mediaID) {
        var options = {
            url: URL_MODULES + "HandleProjectMediaAddCRUD",
            params: {
                projectID: currentProjectID,
                MediaID: mediaID
            },
            isloader: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnProjectImageList();
            }
        }
    }


    function handleProjectMediaDeleteCRUD(mediaID) {
        var options = {
            url: URL_MODULES + "HandleProjectMediaDeleteCRUD",
            params: {
                projectID: currentProjectID,
                MediaID: mediaID
            },
            isloader: true,
            callback: afterData
        };

        me.AJAX.setAJAX(options);

        function afterData(result) {
            if (result.data) {
                returnProjectImageList();
            }
        }
    }

    function handleProjectAddTaskCRUD() {

        var options = {
            url: URL_MODULES + "HandleProjectTaskCRUD",
            params: {
                projectID: currentProjectID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                returnTasksByProject(true);
                handleProjectTaskValidation();
            }
        }
    }

    function handleProjectTaskCopyCRUD(data) {
        var options = {
            url: URL_MODULES + "HandleProjectTaskCopyCRUD",
            params: {
                taskID: data.value
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                returnTasksByProject(false);
                handleProjectTaskValidation();
            }
        }
    }

    function handleProjectTaskDeleteCRUD(data) {
        var options = {
            url: URL_MODULES + "HandleProjectTaskDeleteCRUD",
            params: {
                taskID: data.value
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                returnTasksByProject(false);
                handleProjectTaskValidation();
            }
        }
    }

    function returnTasksByProject(enableFocus = false) {

        var options = {
            url: URL_MODULES + "ReturnTasksByProject",
            params: {
                projectID: currentProjectID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(PROJECT_TASK_TABLE).html(result).enableControls();
                if (enableFocus) {
                    $(PROJECT_TASK_TABLE + " tr").not(".footer").last().find('td.edit').first().find('textarea').focus().focus();
                }
            }
        }
    }

    // prepare project task update for server
    function setProjectTaskFieldCRUD(data) {
        var strReplace = 'EDIT_TASK_';
        var fldName;

        for (var n in tag) {
            if (tag[n] === data.tag) {
                fldName = n.replace(strReplace, '');
                break;
            }
        }

        var taskItem = setProjectTaskItem(data.parentid);
        taskItem[fldName] = data.value;

        handleProjectTaskCRUD(taskItem);
    }

    function handleProjectTaskCRUD(data) {

        var options = {
            url: URL_MODULES + "HandleProjectTaskCRUD",
            params: {
                item: data
            },
            callback: afterData,
            isloader: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result.result) {
                $(ANNUAL_VALUE).html(result.AnnualValue);
                returnTasksByProject(false);
                handleProjectTaskValidation();
            }
        }
    }

    function handleProjectTaskValidation() {

        var options = {
            url: URL_MODULES + "HandleProjectTaskValidation",
            params: {
                projectID: currentProjectID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(PROJECT_VALIDATION_STATUS).html(result).enableControls();
            }
        }
    }

    function openTaskMonthlyMetricModal(data) {
        taskID = data.parentid;
        var options = {
            url: URL_MODULES + "ReturnMetricList",
            params: {
                taskID
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(TASK_MONTHLY_MODAL).html(result).on('hidden.bs.modal', function () {
                    $('body').addClass("modal-open");
                }).modal('show').enableControls();
            }
        }
    }

    function returnProjectLastUpdatedStatus() {
        var options = {
            url: URL_MODULES + "ReturnProjectLastUpdatedStatus",
            params: {
                projectID: currentProjectID,
            },
            callback: afterData,
            isloader: true,
            ishtml: true
        };

        me.AJAX.setAJAX(options);

        function afterData(data) {
            var result = data.data;
            if (result) {
                $(PROJECT_UPDATED_BY).html(result).enableControls();
            }
        }
    }

    /* ========================================================================
     *  Helper Functions
     * ========================================================================
    */


    function handleEditProjectModalCleanup() {
        me.setToolTip();
        $(MODAL_ELEM).remove();
        if (callbackFunction && typeof callbackFunction === 'function') {
            callbackFunction();
        }
    }


    function showProjectModule() {
        $(MODAL_ELEM).off('hidden.bs.modal').on('hidden.bs.modal', function () {
            handleEditProjectModalCleanup();
        }).modal('show');
    }

    /* ========================================================================
     *  module init
     * ========================================================================
    */


    child.init = function () { };
    // Display edit project modal
    // projectID: ID of the project to edit
    // callback: call this function after the modal closes if the user made any changes. It doesn't pass any parameters
    child.loadEditProjectModal = function (projectID, callback, addTask = false, showTaskSection = false) {
        callbackFunction = callback;
        currentProjectID = projectID;
        getEditProjectModal(addTask, showTaskSection);
    };

    child.handleSecondModalClose = function () {
        $('body').addClass("modal-open");
    }

    //   after control event
    child.getAfterControlEvent = function (data) {
        var result = data;
        switch (result.tag) {
            //Job Details
            case tag.CREATE_JOB:
                getCreateJobModal($(MODAL_ELEM).find('[data-tag="' + tag.EDIT_ProjectTitle + '"]').val());
                break;
            // Edit Tab
            case tag.EDIT_ProjectTitle:
            case tag.EDIT_Comment:
            case tag.EDIT_EndDateInitial:
            case tag.EDIT_StartDate:
            case tag.EDIT_ActualCompletedDate:
            case tag.EDIT_OwnerID:
            case tag.EDIT_Priority:
            case tag.EDIT_IsTop50:
            case tag.EDIT_ProjectScope:
            case tag.EDIT_DefinitionOfDone:
            case tag.EDIT_Top50Category:
            case tag.EDIT_JobID:
            case tag.EDIT_EstimatedHours:
            case tag.EDIT_Custom:
                setProjectFieldCRUD(result);
                break;
            case tag.EDIT_EntityID:
                validateEntityType(result);
                break;
            case tag.EDIT_ForecastedCompletionDate:
                projectCompletedDate = result.value;
                handleProjectForecastCompletionDateCRUD(false);
                break;

            // Project status
            case tag.EDIT_People:
            case tag.EDIT_Plan:
            case tag.EDIT_Action:
            case tag.EDIT_WasSuccessful:
                handleProjectTaskStatusCRUD(result);
                break;
            case tag.EDIT_IsComplete:
                handleProjectIsCompleteCRUD(result);
                break;
            case tag.EDIT_IsComplete_Promote:
                handleProjectIsCompleteCRUD(result);
                if (result.value) {
                    me.setConfirmDialogue(label['CompleteAllIncompleteTasksComplete'], tag.EDIT_Tasks_IsComplete, tag.HIDE_MODAL,
                        data.e.closest('[data-callbackprefix]').data('callbackprefix'), null, label['Yes'], label['No']);
                }
                break;
            case tag.EDIT_Tasks_IsComplete:
                me.hideConfirmDialogue(child.handleSecondModalClose);
                handleProjectTaskIsComplete();
                break;
            // Collections Tab
            case tag.CHECK_COLLECTION_PROJECT:
                handleProjectCollectionCRUD(result);
                break;

            // Monthly Impact Tab
            case tag.CHECK_METRIC:
                checkProjectMetric(result);
                break;
            case tag.EDIT_METRIC_IsRequired:
                if (result.value) {
                    openSelectMonthModal(result);
                } else {
                    var item = {
                        MetricID: result.parentid,
                        IsRequired: result.value,
                        TaskID: taskID
                    };
                    handleProjectIsRequiredCRUD(item);
                }
                break;
            case tag.EDIT_METRIC_IsRequired_Date:
                metricItem.RequiredMonthDate = $('[data-fldname="MonthDate"]').val();
                handleProjectIsRequiredCRUD(metricItem);
                break;
            case tag.EDIT_IsFMEARPNReduction:
            case tag.EDIT_FMEALineNumber:
            case tag.EDIT_CurrentRPN:
            case tag.EDIT_RPNReduction:
            case tag.EDIT_SafetyType:
                handleProjectTaskMonthlyMetricCRUD(result);
                break;

            // Associated Entities Tab
            case tag.ADD_ENTITY:
                associateProjectEntity(result);
                break;
            case tag.DELETE_ENTITY:
                disassociateProjectEntity(result);
                break;

            // Other
            case tag.DELETE_PROJECT:
                handleProjectDeleteCRUD(result);
                break;
            case tag.SAVE_LINK:
                handleLinkAddCRUD(result);
                break;
            case tag.DELETE_LINK:
                handleLinkDeleteCRUD(result);
                break;

            case tag.TOGGLE_SECTION:
                expandCollapseSection(data);
                break;

            case tag.UPLOAD_FILE:
                uploadFile(result);
                break;
            case tag.REMOVE_FILE:
                handleProjectAttachmentDeleteCRUD(result);
                break;

            case tag.ADD_IMAGE:
                me.MEDIA_MANAGER.loadMediaUploader(handleImageUpdateCRUD(data), child.handleSecondModalClose);
                break;
            case tag.CLICK_IMAGE:
                var imageList = $('[data-tag=' + tag.CLICK_IMAGE_WITH_PREFIX + ']').map(function () { return $(this).data('parentid') }).toArray();
                me.MEDIA_MANAGER.loadMediaManager(imageList, data.parentid, handleImageUpdateCRUD(data, true), child.handleSecondModalClose, true, true, true);
                break;
            case tag.ADD_TASK:
                handleProjectAddTaskCRUD();
                break;
            case tag.DELETE_TASK:
                handleProjectTaskDeleteCRUD(result);
                break;
            case tag.COPY_TASK:
                handleProjectTaskCopyCRUD(result);
                break;
            case tag.EDIT_TASK_Title:
            case tag.EDIT_TASK_EntityID:
            case tag.EDIT_TASK_OwnerID:
            case tag.EDIT_TASK_ImpactOffset:
            case tag.EDIT_TASK_ImpactAccountID:
            case tag.EDIT_TASK_ImpactType:
            case tag.EDIT_TASK_CalculationType:
            case tag.EDIT_TASK_PartID:
            case tag.EDIT_TASK_PurchasedMaterialID:
            case tag.EDIT_TASK_PerPieceValue:
            case tag.EDIT_TASK_OneTimeValue:
            case tag.EDIT_TASK_AnnualValue:
            case tag.EDIT_TASK_Probability:
            case tag.EDIT_TASK_Duration:
            case tag.EDIT_TASK_IsSoftCost:
            case tag.EDIT_TASK_IsCompleted:
            case tag.EDIT_TASK_IsValidated:
            case tag.EDIT_TASK_Comment:
            case tag.EDIT_TASK_ActualCompletionDate:
            case tag.EDIT_TASK_TaskStatusType:
                setProjectTaskFieldCRUD(result);
                break;
            case tag.EDIT_TASK_ForecastedCompletionDate:
                setProjectTaskFieldCRUD(result);
                const dateTask = moment(result.value, "MM/DD/YYYY");
                const dateProject = moment($('input[data-tag="' + tag.EDIT_ForecastedCompletionDate + '"]').val(), "MM/DD/YYYY");
                if (dateTask.isAfter(dateProject)) {
                    projectCompletedDate = result.value;
                    me.setConfirmDialogue(label['TaskCompletionDateLaterThanProjectForecastDate'], tag.EDIT_PROJECT_ForecastedCompletionDate, tag.HIDE_MODAL,
                        data.e.closest('[data-callbackprefix]').data('callbackprefix'), null, label['Yes'], label['No']);
                }
                break;
            case tag.EDIT_PROJECT_ForecastedCompletionDate:
                me.hideConfirmDialogue(child.handleSecondModalClose);
                handleProjectForecastCompletionDateCRUD(true);
                break;
            case tag.HIDE_MODAL:
                me.hideConfirmDialogue(child.handleSecondModalClose);
                break;
            case tag.TASK_MONTHLY_METRIC:
                openTaskMonthlyMetricModal(data);
                break;
        }
    };

    return child;
}(jQuery, FD));



